import { useDispatch, type DefaultRootState } from 'react-redux';
import { type ThunkDispatch } from '@reduxjs/toolkit';
import { type TypedUseQueryStateResult } from '@reduxjs/toolkit/query/react';
import { type Action } from 'redux';
import { type BBK_FETCH_BASE_QUERY } from '@bbkAdminRedux/rtkq/bbkApi.slice';
import { type Maybe } from '@bbkAdminUtils/utility-types';

export { toDictionary } from '@bbk/editor-contracts/collections';

export type AppDispatch = ThunkDispatch<DefaultRootState, any, Action>;
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();

export type GenericSelectorArgs = TypedUseQueryStateResult<
  unknown,
  unknown,
  typeof BBK_FETCH_BASE_QUERY
>;
export const selectFromResultTyped = <
  T extends unknown,
  ARGS extends GenericSelectorArgs = GenericSelectorArgs,
>(
  res: ARGS
) => {
  type ResType = Omit<ARGS, 'data'> & {
    data: Maybe<T>;
  };
  return res as ResType;
};
